import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to ensure `id` exists in the Redux store.
 * If missing, navigate to fallback route.
 */
export const useIdInStoreGuard = () => {
  const navigate = useNavigate();
  const { id } = useSelector((state) => state.proposal);

  useEffect(() => {
    if (!id) {
      navigate('/', { replace: true });
    }
  }, [id, navigate]);

  return id;
};
